export default {
  login: {
    txt1: "Código secreto no jogo",
    txt2: "Insira o código secreto..",
    txt3: "Verificar",
    txt4: "Selecione seu servidor",
    txt5: "Selecione seu UID...",
    txt6: "Login",
    txt7: "Centro de Ajuda",
    txt8: "Código Inválido"
  },
  nav: {
    txt1: "Início",
    txt2: "Transmissão Ao Vivo",
    txt3: "Classificação",
    txt4: "赛事MVP",
    txt5: "Assistir",
    txt6: "直播互动领周边",
    txt7: "Recompensas",
    txt8: "赛事创作者计划",
  },
  live: {
    txt1: "Cronograma",
    txt2: "Explore mais transmissões",
    txt3: "Horário da live:",
    txt4: "Transmissão Ao Vivo:",
    txt5: "Acesse a transmissão",
    txt6: "Horário da live",
    txt7: "Confronto",
    txt8: "Olá, por favor, faça o login primeiro.",
  },
  process: {
    nav1: "Classificação de Partidas de Pontos",
    nav2: "Eliminatórias - Trajetória",
    nav3: "Classificação de Pontos",
    txt1: "Classificação",
    txt2: "Equipe ",
    txt3: "Servidor",
    txt4: "Ponto",
    txt5: "Divisão",
    txt6: "Matar",
    list: ["赛区Ⅰ", "赛区Ⅱ", "赛区Ⅲ", "赛区Ⅳ"],
    img: require("@/assets/zh-img.jpg"),
  },
  periphery: {
    time1: "2023/11/22",
    title1: "福利一:半决赛-第一场比赛神秘礼包码",
    time2: "2023/11/24",
    title2: "福利二:半决赛-第二场比赛神秘礼包码",
    time3: "2023/11/25",
    title3: "福利三:冠军队伍福利礼包码",
    p1: "竞猜币",
    p2: "Diamante",
    p3: "公会奖章箱",
    p4: "大型zeny宝箱",
    p5: "卡片抽奖券（珍稀）",
    p6: "高级精炼附魔礼盒",
  },
  mvp: {
    txt1: "历史最高数据",
    txt2: "角色服务器",
    txt3: "战队昵称",
    txt4: "角色昵称",
    txt5: "角色等级",
    txt6: "职业",
    txt7: "32强淘汰赛",
    txt8: "总决赛",
  },
  task: {
    loginTip: "Querido aventureiro, faça login primeiro para concluir as missões e ganhe suas recompensas!",
    reward830: "Baú Opc. Gravação Delot *10\n Material de Cultivo de Jornada Astral *50",
    task830: "Assitir por <span>10 minutos</span> em 30/09",
    reward91: "Cinzas de Delot *300\n Material de Cultivo de Jornada Astral *50",
    task91: "Assitir por <span>10 minutos</span> em 02/10",
    reward92: "Pac. Sigiloso Precioso *5 \nMaterial de Cultivo de Jornada Astral *100",
    task92: "Assitir por <span>10 minutos</span> em 04/10",
    reward94: "Pluma Espaço & Tempo *15 \nPluma Luz & Sombra *15",
    task94: "Assitir por <span>15 minutos</span> em 09/10",
    reward96: "Pluma Espaço & Tempo *15 \nPluma Luz & Sombra *15",
    task96: "Assitir por <span>15 minutos</span> em 11/10",
    reward98: "Pac. de Módulos D *3 Pac. de Módulo C *5 \nDiamante *500",
    task98: "Assitir por <span>15 minutos</span> em 13/10",
    rewardTotal2: "Baú Opc. Encantamento *5 \nBolsa do Éden (G) *15",
    taskTotal2: "Complete 3 missões de assistir",
    rewardTotal5: "Cupom de Carta Esquisito *10 Cupom de Gacha *10 Cupom Super Pet *10",
    taskTotal5: "Complete 6 missões de assistir",
    txt7: "Progresso Atual",
    txt8: "Não concluído",
    txt9: "Ver",
    txt10: "Resgatar",
    txt11: "Coletado",
  },
  reward: [
    {
      type: "Eliminatórias",
      item: [
        {
          name: "Campeão",
          image: require("@/assets/lna/re1.png"),
          imageM: require("@/assets/lna/mobile/re1.png"),
          list: [
            {
              name: "Montaria do campeão",
              amount: "",
            },
            {
              name: "Título: Campeão da Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Balão de Fala: Campeão da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Campeão da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "20000",
            },
            {
              name: "Diamante",
              amount: "5000",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "10",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "30",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "40",
            },
            {
              name: "Capítulo da Lua",
              amount: "5",
            },
            {
              name: "Baú da Estátua do Rei",
              amount: "10",
            },
          ],
        },
        {
          name: "Vice - Campeão",
          image: require("@/assets/lna/re2.png"),
          imageM: require("@/assets/lna/mobile/re2.png"),
          list: [
            {
              name: "Título: Vice-Campeão da Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Balão de Fala: Vice-Campeão da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Vice-Campeão da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "10000",
            },
            {
              name: "Diamante",
              amount: "4500",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "10",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "25",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "36",
            },
            {
              name: "Capítulo da Lua",
              amount: "4",
            },
            {
              name: "Baú da Estátua do Rei",
              amount: "8",
            },
          ],
        },
        {
          name: "3º~4º Lugar",
          image: require("@/assets/lna/re3.png"),
          imageM: require("@/assets/lna/mobile/re3.png"),
          list: [
            {
              name: "Título: Top 4 da Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Balão de Fala: Top 4 da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Top 4 da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "17",
            },
            {
              name: "Nyan Berry",
              amount: "5000",
            },
            {
              name: "Diamante",
              amount: "4000",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "8",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "20",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "32",
            },
            {
              name: "Capítulo da Lua",
              amount: "3",
            },
            {
              name: "Baú da Estátua do Rei",
              amount: "6",
            },
          ],
        },
        {
          name: " 5º~8º Lugar",
          image: require("@/assets/lna/re4.png"),
          imageM: require("@/assets/lna/mobile/re4.png"),
          list: [
            {
              name: "Título: Top 8 da Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Balão de Fala: Top 8 da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Top 8 da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "15",
            },
            {
              name: "Nyan Berry",
              amount: "3000",
            },
            {
              name: "Diamante",
              amount: "3000",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "6",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "15",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "28",
            },
            {
              name: "Capítulo da Lua",
              amount: "2",
            },
            {
              name: "Baú da Estátua do Rei",
              amount: "4",
            },
          ],
        },
        {
          name: "9º~16º Lugar",
          image: require("@/assets/lna/re5.png"),
          imageM: require("@/assets/lna/mobile/re5.png"),
          list: [
            {
              name: "Título: Top 16 da Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Balão de Fala: Top 32 da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Top 32 da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "7",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamante",
              amount: "2000",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "4",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "10",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "24",
            },
            {
              name: "Capítulo da Lua",
              amount: "2",
            },
            {
              name: "Baú da Estátua do Rei",
              amount: "2",
            },
          ],
        },
        {
          name: "17º~32º Lugar",
          image: require("@/assets/lna/re6.png"),
          imageM: require("@/assets/lna/mobile/re6.png"),
          list: [
            {
              name: "Título: Top 32 da Copa Thor (2024)",
              amount: "",
            },
            {
              name: "Balão de Fala: Top 32 da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Top 32 da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "5",
            },
            {
              name: "Nyan Berry",
              amount: "1500",
            },
            {
              name: "Diamante",
              amount: "1500",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "2",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "5",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "20",
            },
            {
              name: "Capítulo da Lua",
              amount: "1",
            },
          ],
        },
      ],
    },
    {
      type: "Partidas de Pontos",
      item: [
        {
          name: "Avance para 1-4",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Balão de Fala: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "40",
            },
            {
              name: "Nyan Berry",
              amount: "2500",
            },
            {
              name: "Diamante",
              amount: "2500",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "3",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "30",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "30",
            },
            {
              name: "Baú Opc. Espaço e Tempo",
              amount: "50",
            },
            {
              name: "Retrato: Elite da Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Avance para 5-8",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Balão de Fala: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "35",
            },
            {
              name: "Nyan Berry",
              amount: "2300",
            },
            {
              name: "Diamante",
              amount: "2300",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "3",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "25",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "25",
            },
            {
              name: "Baú Opc. Espaço e Tempo",
              amount: "45",
            },
            {
              name: "Retrato: Elite da Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Avance para 9-16",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Balão de Fala: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "33",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamante",
              amount: "2000",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "3",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "20",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "20",
            },
            {
              name: "Baú Opc. Espaço e Tempo",
              amount: "40",
            },
            {
              name: "Retrato: Elite da Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Avance para 17-32",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Balão de Fala: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "30",
            },
            {
              name: "Nyan Berry",
              amount: "1900",
            },
            {
              name: "Diamante",
              amount: "1900",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "3",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "15",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "19",
            },
            {
              name: "Baú Opc. Espaço e Tempo",
              amount: "38",
            },
            {
              name: "Retrato: Elite da Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Eliminado",
          image: require("@/assets/lna/re7.png"),
          imageM: require("@/assets/lna/mobile/re7.png"),
          list: [
            {
              name: "Título: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Balão de Fala: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Moldura: Elite da Copa Thor",
              amount: "",
            },
            {
              name: "Painel de Campeão",
              amount: "28",
            },
            {
              name: "Nyan Berry",
              amount: "1800",
            },
            {
              name: "Diamante",
              amount: "1800",
            },
            {
              name: "Marca Laranja Opcional",
              amount: "2",
            },
            {
              name: "Baú Opc. de Estátua (D)",
              amount: "10",
            },
            {
              name: "Baú Opc. Luz e Sombra",
              amount: "18",
            },
            {
              name: "Baú Opc. Espaço e Tempo",
              amount: "36",
            },
            {
              name: "Retrato: Elite da Copa Thor",
              amount: "",
            },
          ],
        },
        {
          name: "Recompensa da Participação",
          image: require("@/assets/lna/re8.png"),
          imageM: require("@/assets/lna/mobile/re8.png"),
          list: [
            {
              name: "Diamante",
              amount: "100",
            },
            {
              name: "Marca do Poder",
              amount: "200",
            },
            {
              name: "Caixa de Presente de Marca Rara Aleatória",
              amount: "1",
            },
            {
              name: "Baú Opc. Espaço e Tempo",
              amount: "5",
            },
            {
              name: "Super Biscoito",
              amount: "5",
            },
            {
              name: "Baú de Pluma Opcional",
              amount: "10",
            },
          ],
        },
      ],
    },
  ],
  dia: {
    txt1: "Código de Resgate",
    txt2: "Copiar",
    txt3: "Copiado",
  },
};
